export default class CommonRecoveryMediator {
  /** Código del mediador. Ejemplo: M1234 */
  mediator!: string

  constructor(data: { mediator?: string }) {
    this.mediator = data?.mediator ?? ''
  }
}
